import { render, staticRenderFns } from "./notationAdd.vue?vue&type=template&id=3a59ae40&scoped=true"
import script from "./notationAdd.vue?vue&type=script&lang=js"
export * from "./notationAdd.vue?vue&type=script&lang=js"
import style0 from "./notationAdd.vue?vue&type=style&index=0&id=3a59ae40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a59ae40",
  null
  
)

export default component.exports